"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// aptoken/frontend/src/components/Footer.js

var Footer = function Footer() {
  return /*#__PURE__*/_react["default"].createElement("footer", {
    style: styles.footer
  }, /*#__PURE__*/_react["default"].createElement("p", null, "Powered by ", /*#__PURE__*/_react["default"].createElement("strong", null, "DSC NextGen \xA9 2025")));
};
var styles = {
  footer: {
    textAlign: "center",
    padding: "2px 0",
    background: "#a79b9bff",
    position: "fixed",
    // changed from sticky→fixed to then to static
    bottom: 0,
    width: "100%",
    fontSize: "12px",
    color: "#333",
    borderTop: "1px solid #ddd",
    marginTop: "auto"
  }
};
var _default = exports["default"] = Footer;